import { promptPriceChangeReason } from '../utils/Helpers';

export default class DtnService {
    storeDtn = (job, data) => {
        return axios.post(`/jobs/${job}/dtn`, data); // Admin
    };

    storeProviderDtn = (provider, job, data) => {
        return axios.post(`/providers/${provider}/jobs/${job}/dtn`, data); // Provider
    };

    updateDtn = (job, data) => {
        if (data instanceof FormData) {
            data.append('_method', 'PATCH');
            return this.submitDtnUpdate(`/jobs/${job}/dtn/update`, data); // Admin
        }
        return axios.patch(`/jobs/${job}/dtn/update`, data);
    };

    submitDtnUpdate = (url, formData) => {
        return axios.post(url, formData).catch((err) => {
            if (err.response && err.response.status === 422 && err.response.data.requires_price_change_reason) {
                return promptPriceChangeReason().then((reason) => {
                    if (!reason) {
                        return Promise.reject(err);
                    }

                    formData.set('price_change_reason', reason);
                    return this.submitDtnUpdate(url, formData);
                });
            }

            if (err.response && err.response.status === 403 && err.response.data.message) {
                window.swal.fire({
                    icon: 'error',
                    title: 'Unable to save',
                    text: err.response.data.message,
                });
            }

            return Promise.reject(err);
        });
    };

    updateProviderDtn = (provider, job, data) => {
        let request;
        if (data instanceof FormData) {
            data.append('_method', 'PATCH');
            request = axios.post(`/providers/${provider}/jobs/${job}/dtn/update`, data); // Provider
        } else {
            request = axios.patch(`/providers/${provider}/jobs/${job}/dtn/update`, data);
        }

        return request.catch((err) => {
            if (err.response && err.response.status === 403 && err.response.data.message) {
                window.swal.fire({
                    icon: 'error',
                    title: 'Unable to save',
                    text: err.response.data.message,
                });
            }

            return Promise.reject(err);
        });
    };

    updateJobStatus = (job, data) => {
        return axios.post(`/jobs/${job}/status`, data); // Admin
    };

    requiresDtnReason(jobId) {
        return axios.get(`/jobs/${jobId}/requires-dtn-reason`);
    }

    requiresSuperadminReview(jobId) {
    return axios.get(`/jobs/${jobId}/has-pending-superadmin`);
}
}
